import type { MarketResearchDemandAnalysisSearchTrendsListParams } from "@similarweb/pro-api-client";

import { serializeSearchTrendsQueryParams } from "../hooks/useKeywordListsNodeAPIQueryParams";

export const getSearchTrendsExcelURL = (queryParams: MarketResearchDemandAnalysisSearchTrendsListParams): string => {
    const serializedParams = serializeSearchTrendsQueryParams(queryParams);
    return `/api/MarketResearch/DemandAnalysis/SearchTrends/Excel?${serializedParams}`;
};

export const getSearchTrendsByCountryExcelURL = (
    queryParams: MarketResearchDemandAnalysisSearchTrendsListParams,
): string => {
    const serializedParams = serializeSearchTrendsQueryParams(queryParams);
    return `/api/MarketResearch/DemandAnalysis/SearchTrendsByCountry/Excel?${serializedParams}`;
};
